const liveHostnames = [
  'app.cometchat.com',
  'app-beta.cometchat.com',
  'appnew.cometchat.com',
  // 'app-beta.cometchat-staging.com',
  // 'localhost',
]

const shouldCaptureGTMEvents = () => {
  return liveHostnames.includes(window.location.hostname)
}

const isLiveEnv = () => {
  
  return liveHostnames.includes(window.location.hostname)
}

let constVar: any
if (isLiveEnv()) {
  constVar = {
    isLiveEnv: true,
    isStagingEnv: false,
    version: '/v2.0/',
    customerDomain: 'https://apimgmt.cc-cluster-2.io/',
    useChatApiWrapper: true,
    // call-api wrapper backend not live yet — go live planned Mon; keep calls on direct path until then.
    useCallApiWrapper: true,
    legacyDomain: 'api.cometchat.com/v1.8/',
    analyticsDomainV1: 'cometchat.io/v1/',
    analyticsDomainV2: 'cometchat.io/v2/',
    googleClientId: '1068889534322-dqiqpq3keha6dt42lk199a63s6kraet1.apps.googleusercontent.com',
    stripePublishableKey: 'pk_live_LXdkHgha2mJlf0kaU4Odb2jg',
    domainToSetCookies: 'cometchat.com',
    betaDashboardHostingUrls: {
      old: 'https://app.cometchat.com/',
      new: 'https://app-beta.cometchat.com/',
    },
    builderDomain: 'https://preview.cometchat.com',
    campaignsDomain: 'https://campaigns.cc-cluster-2.io',
    chatBuilderPublicApiUrl: 'https://apivcb.cc-cluster-2.io/v1',
  }
} else {
  constVar = {
    isLiveEnv: false,
    isStagingEnv: true,
    version: '/v2.0/',
    customerDomain: 'https://apimgmt.cometchat-staging.com/',
    // customerDomain: 'https://apimgmt-green.cometchat.io/',
    // customerDomain: 'https://apimgmt-laravel.cometchat-staging.com/',
    useChatApiWrapper: true,
    // call-api wrapper backend not live yet — go live planned Mon; keep calls on direct path until then.
    useCallApiWrapper: true,
    legacyDomain: 'api.cometchat-staging.com/v1.8/',
    analyticsDomainV1: 'cometchat-staging.com/v1/',
    analyticsDomainV2: 'cometchat-staging.com/v2/',
    googleClientId: '1068889534322-dqiqpq3keha6dt42lk199a63s6kraet1.apps.googleusercontent.com', // dev server
    stripePublishableKey: 'pk_test_jCr9gCbm7rXj7VLFLYFknmJJ',
    domainToSetCookies: window.location.hostname,
    betaDashboardHostingUrls: {
      old: 'https://app.cometchat-staging.com/',
      new: 'https://app-beta.cometchat-staging.com/',
    },
    builderDomain: 'https://builder.cometchat-staging.com',
    campaignsDomain: 'https://campaigns.cometchat-staging.com',
    chatBuilderPublicApiUrl: 'https://apivcb.cometchat-staging.com/v1',
  }
}

if (shouldCaptureGTMEvents()) {
  constVar.captureGTMEvents = true
} else {
  constVar.captureGTMEvents = false
}

constVar.extensions = {
  'email-notification': {
    cost: '100.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: true,
  },

  'human-moderation': {
    cost: '1,000.00',
    newPlanNames: ['Scale', 'Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: true,
  },
  'image-moderation': {
    cost: '175.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  'link-preview': {
    cost: '25.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  'message-translation': {
    cost: '250.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  'profanity-filter': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  'push-notification': {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  'sentiment-analysis': {
    cost: '500.00',
    newPlanNames: ['Scale', 'Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: true,
  },
  'smart-reply': {
    cost: '100.00',
    newPlanNames: ['Scale', 'Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: true,
  },
  'sms-notification': {
    cost: '150.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: true,
  },
  'thumbnail-generation': {
    cost: '25.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  broadcast: {
    cost: '100.00',
    newPlanNames: [],
    legacyPlans: true,
  },
  widget: {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: true,
  },
  emojis: {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'xss-filter': {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'voice-transcription': {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: false,
  },
  'data-masking': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'rich-media': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'virus-malware-scanner': {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  reactions: {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  stickers: {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  polls: {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: false,
  },
  whiteboard: {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  document: {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'pin-message': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'save-message': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  mentions: {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'gifs-giphy': {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'gifs-tenor': {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'stickers-stipop': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'gifs-gfycat': {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'email-replies': {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  'url-shortener-tinyurl': {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  'url-shortener-bitly': {
    cost: '0.00',
    newPlanNames: ['Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  'disappearing-messages': {
    cost: '0.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  e2ee: {
    cost: '0.00',
    newPlanNames: ['Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  reminders: {
    cost: '0.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  intercom: {
    cost: '0.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  chatwoot: {
    cost: '0.00',
    newPlanNames: ['Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  'live-migration-applozic': {
    cost: '0.00',
    newPlanNames: ['Startup', 'Growth', 'Scale', 'Enterprise', 'Multi-tenant'],
    legacyPlans: false,
  },
  avatar: {
    cost: '0.00',
    newPlanNames: [
      'Startup',
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'message-shortcuts': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'report-user': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'report-message': {
    cost: '0.00',
    newPlanNames: [
      'Growth',
      'Scale',
      'Enterprise',
      'Single Event',
      'Unlimited Events',
      'Multi-tenant',
    ],
    legacyPlans: false,
  },
  'slow-mode': {
    cost: '0.00',
    newPlanNames: ['Enterprise', 'Single Event', 'Unlimited Events', 'Multi-tenant'],
    legacyPlans: false,
  },
  'com.cometchat.badwordfilter': {
    cost: '0.00',
    v1: true,
  },
  'com.cometchat.e2ee-by-virgil-security': {
    cost: '0.00',
    v1: true,
  },
  'com.cometchat.pushnotification': {
    cost: '0.00',
    v1: true,
  },
}

constVar.extensionTypes = {
  integrations: ['widget'],
  notifications: [
    'email-notification',
    'push-notification',
    'sms-notification',
    'com.cometchat.pushnotification',
    'email-replies',
  ],
  moderation: [
    'human-moderation',
    'image-moderation',
    'profanity-filter',
    'sentiment-analysis',
    'xss-filter',
    'data-masking',
    'virus-malware-scanner',
    'report-user',
    'report-message',
    'slow-mode',
    'com.cometchat.badwordfilter',
    'com.cometchat.e2ee-by-virgil-security',
  ],
  user_experience: [
    'link-preview',
    'thumbnail-generation',
    'voice-transcription',
    'rich-media',
    'pin-message',
    'save-message',
    'url-shortener-tinyurl',
    'url-shortener-bitly',
    'avatar',
    'message-shortcuts',
  ],
  user_engagement: [
    'message-translation',
    'smart-reply',
    'emojis',
    'reactions',
    'stickers',
    'polls',
    'broadcast',
    'mentions',
    'gifs-giphy',
    'gifs-tenor',
    'gifs-gfycat',
    'stickers-stipop',
    'reminders',
  ],
  collaboration: ['whiteboard', 'document'],
  security: ['disappearing-messages', 'e2ee'],
  customer_support: ['intercom', 'chatwoot'],
  live_migration: ['live-migration-applozic'],
}
constVar.plans_legacy = {
  0: {
    id: 'meteoroid-(10-19)',
    price: 57.0,
    marks: {
      0: '0',
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '50000',
    },
  },
  1: {
    id: 'asteroid-(10-19)',
    price: 96.0,
    marks: {
      0: '0',
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
      11: '',
      12: '',
      13: '',
      14: '100,000',
    },
  },
  2: {
    id: 'custom',
    marks: {},
  },
}
constVar.plans = {
  0: {
    id: 'meteoroid-10k-(2020-05)',
    price: 138.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
    },
    extensionIds: ['profanity-filter', 'push-notification', 'widget', 'xss-filter', 'emojis'],
  },
  1: {
    id: 'asteroid-10k-(2020-05)',
    price: 283.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
    ],
  },
  2: {
    id: 'moon-10k-(2020-05)',
    price: 578.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'email-notification',
      'image-moderation',
      'message-translation',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
    ],
  },
  3: {
    id: 'planet-10k-(2020-05)',
    price: 1018.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'email-notification',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'smart-reply',
      'sms-notification',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'virus-malware-scanner',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
    ],
  },
}

constVar.plansV3 = {
  0: {
    id: 'startup-10k-(2021-01)',
    price: 283.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    maxMarks: 5,
    extensionIds: [
      'thumbnail-generation',
      'link-preview',
      'emojis',
      'push-notification',
      'widget',
      'xss-filter',
      'avatar',
    ],
  },
  1: {
    id: 'growth-10k-(2021-01)',
    price: 578.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    maxMarks: 5,
    extensionIds: [
      'profanity-filter',
      'thumbnail-generation',
      'link-preview',
      'emojis',
      'push-notification',
      'widget',
      'xss-filter',
      'rich-media',
      'reactions',
      'stickers',
      'message-translation',
      'whiteboard',
      'document',
      'email-notification',
      'sms-notification',
      'image-moderation',
      'data-masking',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
    ],
  },
  2: {
    id: 'scale-10k-(2021-01)',
    price: 1018,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    maxMarks: 5,
    extensionIds: [
      'profanity-filter',
      'thumbnail-generation',
      'link-preview',
      'emojis',
      'push-notification',
      'widget',
      'xss-filter',
      'rich-media',
      'reactions',
      'stickers',
      'message-translation',
      'whiteboard',
      'document',
      'email-notification',
      'sms-notification',
      'image-moderation',
      'data-masking',
      'voice-transcription',
      'smart-reply',
      'polls',
      'virus-malware-scanner',
      'sentiment-analysis',
      'human-moderation',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
    ],
  },
  3: {
    id: 'enterprise-10k-(2021-01)',
    price: 1313,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    maxMarks: 5,
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'email-notification',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'smart-reply',
      'sms-notification',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'virus-malware-scanner',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
      'slow-mode',
    ],
  },
  4: {
    id: 'single-1k-(2021-03)',
    price: 283,
    marks: {
      0: '25',
      1: '100',
      2: '1k',
      3: '2.5k',
      4: '5k',
      5: '10k',
      6: '10k+',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
      'slow-mode',
    ],
  },
  5: {
    id: 'multiple-10k-(2021-01)',
    price: 999,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
      'slow-mode',
    ],
  },
  6: {
    id: 'multi-tenant-10k-(2021-01)',
    price: 999,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '100k',
      5: '100k+',
    },
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'email-notification',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'smart-reply',
      'sms-notification',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'virus-malware-scanner',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
      'slow-mode',
    ],
  },
}

constVar.plansV4 = {
  0: {
    id: 'essentials-10k-2023-01',
    price: 379.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '50k+',
    },
    maxMarks: 4,
    extensionIds: [
      'thumbnail-generation',
      'link-preview',
      'emojis',
      'push-notification',
      'widget',
      'xss-filter',
      'avatar',
    ],
  },
  1: {
    id: 'pro-10k-2023-01',
    price: 799.0,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '50k+',
    },
    maxMarks: 4,
    extensionIds: [
      'profanity-filter',
      'thumbnail-generation',
      'link-preview',
      'emojis',
      'push-notification',
      'widget',
      'xss-filter',
      'rich-media',
      'reactions',
      'stickers',
      'message-translation',
      'whiteboard',
      'document',
      'email-notification',
      'sms-notification',
      'image-moderation',
      'data-masking',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
    ],
  },
  2: {
    id: 'enterprise',
    price: 1529,
    marks: {
      0: '1k',
      1: '10k',
      2: '25k',
      3: '50k',
      4: '50k+',
    },
    maxMarks: 4,
    extensionIds: [
      'profanity-filter',
      'push-notification',
      'thumbnail-generation',
      'link-preview',
      'email-notification',
      'image-moderation',
      'message-translation',
      'sentiment-analysis',
      'smart-reply',
      'sms-notification',
      'widget',
      'xss-filter',
      'emojis',
      'reactions',
      'stickers',
      'data-masking',
      'rich-media',
      'virus-malware-scanner',
      'voice-transcription',
      'human-moderation',
      'polls',
      'whiteboard',
      'document',
      'pin-message',
      'save-message',
      'stickers-stipop',
      'avatar',
      'message-shortcuts',
      'report-user',
      'report-message',
      'slow-mode',
    ],
  },
}

constVar.nonCustomPlansIDList = [
  // phase 1 plans
  'meteoroid-(10-19)',
  'asteroid-(10-19)',
  // phase 2 plans
  'meteoroid-1k-(2020-05)',
  'meteoroid-10k-(2020-05)',
  'meteoroid-25k-(2020-05)',
  'meteoroid-50k-(2020-05)',
  'meteoroid-100k-(2020-05)',
  'asteroid-1k-(2020-05)',
  'asteroid-10k-(2020-05)',
  'asteroid-25k-(2020-05)',
  'asteroid-50k-(2020-05)',
  'asteroid-100k-(2020-05)',
  'moon-1k-(2020-05)',
  'moon-10k-(2020-05)',
  'moon-25k-(2020-05)',
  'moon-50k-(2020-05)',
  'moon-100k-(2020-05)',
  'planet-1k-(2020-05)',
  'planet-10k-(2020-05)',
  'planet-25k-(2020-05)',
  'planet-50k-(2020-05)',
  'planet-100k-(2020-05)',
  // phase3 plans
  'free-25-(2021-01)',
  'single-25-(2021-01)',
  'startup-1k-(2021-01)',
  'startup-10k-(2021-01)',
  'startup-25k-(2021-01)',
  'startup-50k-(2021-01)',
  'startup-100k-(2021-01)',
  'growth-1k-(2021-01)',
  'growth-10k-(2021-01)',
  'growth-25k-(2021-01)',
  'growth-50k-(2021-01)',
  'growth-100k-(2021-01)',
  'scale-1k-(2021-01)',
  'scale-10k-(2021-01)',
  'scale-25k-(2021-01)',
  'scale-50k-(2021-01)',
  'scale-100k-(2021-01)',
  // 'enterprise-1k-(2021-01)',
  // 'enterprise-10k-(2021-01)',
  // 'enterprise-25k-(2021-01)',
  // 'enterprise-50k-(2021-01)',
  // 'enterprise-100k-(2021-01)',
  'single-100-(2021-01)',
  'single-1k-(2021-03)',
  'single-2500-(2021-03)',
  'single-5k-(2021-03)',
  'single-10k-(2021-03)',
  // 'nebula-1k-(2020-05)',
  // 'nebula-10k-(2020-05)',
  // 'nebula-25k-(2020-05)',
  // 'nebula-50k-(2020-05)',
  // 'nebula-100k-(2020-05)',
  'essentials-1k-2023-01',
  'essentials-10k-2023-01',
  'essentials-25k-2023-01',
  'essentials-50k-2023-01',
  'pro-1k-2023-01',
  'pro-10k-2023-01',
  'pro-25k-2023-01',
  'pro-50k-2023-01',
  'free-2023-01',
  'annual-essentials-1k-2023-01',
  'annual-essentials-10k-2023-01',
  'annual-essentials-25k-2023-01',
  'annual-essentials-50k-2023-01',
  'annual-pro-1k-2023-01',
  'annual-pro-10k-2023-01',
  'annual-pro-25k-2023-01',
  'annual-pro-50k-2023-01',
  'growth-500-2024-03',
  'growth-5k-2024-03',
  'growth-10k-2024-03',
  'annual-growth-500-2024-03',
  'annual-growth-5k-2024-03',
  'annual-growth-10k-2024-03',
  'scale-500-2024-03',
  'scale-5k-2024-03',
  'scale-10k-2024-03',
  'annual-scale-500-2024-03',
  'annual-scale-5k-2024-03',
  'annual-scale-10k-2024-03',
  'basic-1k-2024-09',
  'basic-10k-2024-09',
  'basic-25k-2024-09',
  'basic-50k-2024-09',
  'annual-basic-1k-2024-09',
  'annual-basic-10k-2024-09',
  'annual-basic-25k-2024-09',
  'annual-basic-50k-2024-09',
  'advanced-1k-2024-09',
  'advanced-10k-2024-09',
  'advanced-25k-2024-09',
  'advanced-50k-2024-09',
  'annual-advanced-1k-2024-09',
  'annual-advanced-10k-2024-09',
  'annual-advanced-25k-2024-09',
  'annual-advanced-50k-2024-09',
  // phase 7 plans
  'basic-1k-2026-01',
  'basic-10k-2026-01',
  'basic-25k-2026-01',
  'basic-50k-2026-01',
  'annual-basic-1k-2026-01',
  'annual-basic-10k-2026-01',
  'annual-basic-25k-2026-01',
  'annual-basic-50k-2026-01',
  'advanced-1k-2026-01',
  'advanced-10k-2026-01',
  'advanced-25k-2026-01',
  'advanced-50k-2026-01',
  'annual-advanced-1k-2026-01',
  'annual-advanced-10k-2026-01',
  'annual-advanced-25k-2026-01',
  'annual-advanced-50k-2026-01',
]

constVar.nonCustomPlansCostList = {
  'meteoroid-(10-19)': 57,
  'asteroid-(10-19)': 96,
  'meteoroid-1k-(2020-05)': 49,
  'meteoroid-10k-(2020-05)': 138,
  'meteoroid-25k-(2020-05)': 287,
  'meteoroid-50k-(2020-05)': 534,
  'meteoroid-100k-(2020-05)': 1024,
  'asteroid-1k-(2020-05)': 149,
  'asteroid-10k-(2020-05)': 283,
  'asteroid-25k-(2020-05)': 507,
  'asteroid-50k-(2020-05)': 879,
  'asteroid-100k-(2020-05)': 1624,
  'moon-1k-(2020-05)': 399,
  'moon-10k-(2020-05)': 578,
  'moon-25k-(2020-05)': 877,
  'moon-50k-(2020-05)': 1374,
  'moon-100k-(2020-05)': 2369,
  'planet-1k-(2020-05)': 749,
  'planet-10k-(2020-05)': 1018,
  'planet-25k-(2020-05)': 1467,
  'planet-50k-(2020-05)': 2214,
  'planet-100k-(2020-05)': 3709,

  // phase 3 plans
  'startup-1k-(2021-01)': 149,
  'startup-10k-(2021-01)': 283,
  'startup-25k-(2021-01)': 507,
  'startup-50k-(2021-01)': 879,
  'startup-100k-(2021-01)': 1624,
  'growth-1k-(2021-01)': 399,
  'growth-10k-(2021-01)': 578,
  'growth-25k-(2021-01)': 876,
  'growth-50k-(2021-01)': 1374,
  'growth-100k-(2021-01)': 2369,
  'scale-1k-(2021-01)': 749,
  'scale-10k-(2021-01)': 1018,
  'scale-25k-(2021-01)': 1467,
  'scale-50k-(2021-01)': 2214,
  'scale-100k-(2021-01)': 3709,
  'free-25-(2021-01)': 0,
  'single-25-(2021-01)': 0,
  'single-100-(2021-01)': 149,
  'single-1k-(2021-03)': 283,
  'single-2500-(2021-03)': 507,
  'single-5k-(2021-03)': 879,
  'single-10k-(2021-03)': 1624,
  // phase 4 plans
  'essentials-1k-2023-01': 109,
  'essentials-10k-2023-01': 379,
  'essentials-25k-2023-01': 829,
  'essentials-50k-2023-01': 1579,
  'pro-1k-2023-01': 529,
  'pro-10k-2023-01': 799,
  'pro-25k-2023-01': 1249,
  'pro-50k-2023-01': 1999,
  'free-2023-01': 0,
}
constVar.phase2PlanNameList = {
  'meteoroid-1k-(2020-05)': 'Meteoroid 1k',
  'meteoroid-10k-(2020-05)': 'Meteoroid 10k',
  'meteoroid-25k-(2020-05)': 'Meteoroid 25k',
  'meteoroid-50k-(2020-05)': 'Meteoroid 50k',
  'meteoroid-100k-(2020-05)': 'Meteoroid 100k',
  'asteroid-1k-(2020-05)': 'Asteroid 1k',
  'asteroid-10k-(2020-05)': 'Asteroid 10k',
  'asteroid-25k-(2020-05)': 'Asteroid 25k',
  'asteroid-50k-(2020-05)': 'Asteroid 50k',
  'asteroid-100k-(2020-05)': 'Asteroid 100k',
  'moon-1k-(2020-05)': 'Moon 1k',
  'moon-10k-(2020-05)': 'Moon 10k',
  'moon-25k-(2020-05)': 'Moon 25k',
  'moon-50k-(2020-05)': 'Moon 50k',
  'moon-100k-(2020-05)': 'Moon 100k',
  'planet-1k-(2020-05)': 'Planet 1k',
  'planet-10k-(2020-05)': 'Planet 10k',
  'planet-25k-(2020-05)': 'Planet 25k',
  'planet-50k-(2020-05)': 'Planet 50k',
  'planet-100k-(2020-05)': 'Planet 100k',
}

constVar.phase3PlanNameList = {
  'startup-1k-(2021-01)': 'Startup 1k',
  'startup-10k-(2021-01)': 'Startup 10k',
  'startup-25k-(2021-01)': 'Startup 25k',
  'startup-50k-(2021-01)': 'Startup 50k',
  'startup-100k-(2021-01)': 'Startup 100k',
  'startup-200k-(2021-01)': 'Startup 200k',
  'growth-1k-(2021-01)': 'Growth 1k',
  'growth-10k-(2021-01)': 'Growth 10k',
  'growth-25k-(2021-01)': 'Growth 25k',
  'growth-50k-(2021-01)': 'Growth 50k',
  'growth-100k-(2021-01)': 'Growth 100k',
  'growth-200k-(2021-01)': 'Growth 200k',
  'scale-1k-(2021-01)': 'Scale 1k',
  'scale-10k-(2021-01)': 'Scale 10k',
  'scale-25k-(2021-01)': 'Scale 25k',
  'scale-50k-(2021-01)': 'Scale 50k',
  'scale-100k-(2021-01)': 'Scale 100k',
  'scale-200k-(2021-01)': 'Scale 200k',
  'enterprise-10k-(2021-01)': 'Enterprise',
  // 'enterprise-25k-(2021-01)': 'Enterprise 25k',
  // 'enterprise-50k-(2021-01)': 'Enterprise 50k',
  // 'enterprise-100k-(2021-01)': 'Enterprise 100k',
  // 'enterprise-200k-(2021-01)': 'Enterprise 200k',
  'single-25-(2021-01)': 'Single Event 25',
  'single-100-(2021-01)': 'Single Event 100',
  'single-1k-(2021-03)': 'Single Event 1k',
  'single-2500-(2021-03)': 'Single Event 2.5k',
  'single-5k-(2021-03)': 'Single Event 5k',
  'single-10k-(2021-03)': 'Single Event 10k',
  'multiple-10k-(2021-01)': 'Unlimited Events',
  'multi-tenant-10k-(2021-01)': 'Multi-tenant',
  'free-25-(2021-01)': 'Free 25',
  // phase 4
  'essentials-1k-2023-01': 'Essentials 1k',
  'essentials-10k-2023-01': 'Essentials 10k',
  'essentials-25k-2023-01': 'Essentials 25k',
  'essentials-50k-2023-01': 'Essentials 50k',
  'pro-1k-2023-01': 'Pro 1k',
  'pro-10k-2023-01': 'Pro 10k',
  'pro-25k-2023-01': 'Pro 25k',
  'pro-50k-2023-01': 'Pro 50k',
  'free-2023-01': 'Developer',
}

constVar.phase3PlanDescList = {
  'startup-10k-(2021-01)': 'Best for small apps & websites',
  'growth-10k-(2021-01)': 'Best for live apps & websites',
  'scale-10k-(2021-01)': 'Best for established apps & websites',
  'enterprise-10k-(2021-01)': 'Best for unique requirements that need to scale',
  'single-1k-(2021-03)': 'Best for businesses running single one-off events',
  'multiple-10k-(2021-01)': 'Best for businesses running multiple events',
  'multi-tenant-10k-(2021-01)': 'Best for SaaS businesses that need to support multiple customers',
}

constVar.phase4PlanDescList = {
  'essentials-10k-2023-01': 'A streamlined, efficient package designed for startups',
  'pro-10k-2023-01': 'A feature-rich package designed to boost user engagement and retention',
  enterprise: 'A feature-rich package designed to boost user engagement and retention',
  'free-2023-01': 'Developer free plan with 25 MAU',
}

constVar.phase2PlansIDList = [
  'meteoroid-1k-(2020-05)',
  'meteoroid-10k-(2020-05)',
  'meteoroid-25k-(2020-05)',
  'meteoroid-50k-(2020-05)',
  'meteoroid-100k-(2020-05)',
  'asteroid-1k-(2020-05)',
  'asteroid-10k-(2020-05)',
  'asteroid-25k-(2020-05)',
  'asteroid-50k-(2020-05)',
  'asteroid-100k-(2020-05)',
  'moon-1k-(2020-05)',
  'moon-10k-(2020-05)',
  'moon-25k-(2020-05)',
  'moon-50k-(2020-05)',
  'moon-100k-(2020-05)',
  'planet-1k-(2020-05)',
  'planet-10k-(2020-05)',
  'planet-25k-(2020-05)',
  'planet-50k-(2020-05)',
  'planet-100k-(2020-05)',
]
// phase 4
constVar.phase4PlanNameList = {
  'essentials-1k-2023-01': 'Essentials 1k',
  'essentials-10k-2023-01': 'Essentials 10k',
  'essentials-25k-2023-01': 'Essentials 25k',
  'essentials-50k-2023-01': 'Essentials 50k',
  'pro-1k-2023-01': 'Pro 1k',
  'pro-10k-2023-01': 'Pro 10k',
  'pro-25k-2023-01': 'Pro 25k',
  'pro-50k-2023-01': 'Pro 50k',
  'annual-essentials-1k-2023-01': 'Essentials 1k',
  'annual-essentials-10k-2023-01': 'Essentials 10k',
  'annual-essentials-25k-2023-01': 'Essentials 25k',
  'annual-essentials-50k-2023-01': 'Essentials 50k',
  'annual-pro-1k-2023-01': 'Pro 1k',
  'annual-pro-10k-2023-01': 'Pro 10k',
  'annual-pro-25k-2023-01': 'Pro 25k',
  'annual-pro-50k-2023-01': 'Pro 50k',
  'free-2023-01': 'Developer',
  enterprise: 'Custom',
}

// phase 4
constVar.phase5PlanNameList = {
  'growth-500-2024-03': 'Growth 500',
  'growth-5k-2024-03': 'Growth 5k',
  'growth-10k-2024-03': 'Growth 10k',
  'annual-growth-500-2024-03': 'Growth 500',
  'annual-growth-5k-2024-03': 'Growth 5k',
  'annual-growth-10k-2024-03': 'Growth 10k',
  'scale-500-2024-03': 'Scale 500',
  'scale-5k-2024-03': 'Scale 5K',
  'scale-10k-2024-03': 'Scale 10K',
  'annual-scale-500-2024-03': 'Scale 500',
  'annual-scale-5k-2024-03': 'Scale 5K',
  'annual-scale-10k-2024-03': 'Scale 10K',
  'free-2023-01': 'Build',
}

// phase 4
constVar.phase4PlanDescList = {
  'essentials-10k-2023-01': 'A streamlined, efficient package designed for startups',
  'pro-10k-2023-01': 'A feature-rich package designed to boost user engagement and retention',
  enterprise: 'A feature-rich package designed to boost user engagement and retention',
  'free-2023-01': 'Developer free plan with 25 MAU',
}

// phase 4

constVar.phase4PlansIDList = [
  'essentials-1k-2023-01',
  'essentials-10k-2023-01',
  'essentials-25k-2023-01',
  'essentials-50k-2023-01',
  'pro-1k-2023-01',
  'pro-10k-2023-01',
  'pro-25k-2023-01',
  'pro-50k-2023-01',
  'annual-essentials-1k-2023-01',
  'annual-essentials-10k-2023-01',
  'annual-essentials-25k-2023-01',
  'annual-essentials-50k-2023-01',
  'annual-pro-1k-2023-01',
  'annual-pro-10k-2023-01',
  'annual-pro-25k-2023-01',
  'annual-pro-50k-2023-01',
  'free-2023-01',
  'enterprise',
]

constVar.plansRestrictedToUpgrade = [
  'pro-1k-2023-01',
  'pro-10k-2023-01',
  'pro-25k-2023-01',
  'pro-50k-2023-01',
]

// phase 5
// add in increasing order of MAU
constVar.phase5PlansIDList = [
  'growth-500-2024-03',
  'growth-5k-2024-03',
  'growth-10k-2024-03',
  'annual-growth-500-2024-03',
  'annual-growth-5k-2024-03',
  'annual-growth-10k-2024-03',
  'scale-500-2024-03',
  'scale-5k-2024-03',
  'scale-10k-2024-03',
  'annual-scale-500-2024-03',
  'annual-scale-5k-2024-03',
  'annual-scale-10k-2024-03',
  'free-2023-01',
]

constVar.phase5PaidPlanParentID = 'growth-2024-03'
// phase 6
// add in increasing order of MAU
constVar.phase6PlansIDList = [
  'basic-1k-2024-09',
  'basic-10k-2024-09',
  'basic-25k-2024-09',
  'basic-50k-2024-09',
  'annual-basic-1k-2024-09',
  'annual-basic-10k-2024-09',
  'annual-basic-25k-2024-09',
  'annual-basic-50k-2024-09',
  'advanced-1k-2024-09',
  'advanced-10k-2024-09',
  'advanced-25k-2024-09',
  'advanced-50k-2024-09',
  'annual-advanced-1k-2024-09',
  'annual-advanced-10k-2024-09',
  'annual-advanced-25k-2024-09',
  'annual-advanced-50k-2024-09',
  'free-2023-01',
]

// phase 6
constVar.phase6PlanNameList = {
  'basic-1k-2024-09': 'Basic 1k',
  'basic-10k-2024-09': 'Basic 10k',
  'basic-25k-2024-09': 'Basic 25k',
  'basic-50k-2024-09': 'Basic 50k',
  'annual-basic-1k-2024-09': 'Basic 1k',
  'annual-basic-10k-2024-09': 'Basic 10k',
  'annual-basic-25k-2024-09': 'Basic 25k',
  'annual-basic-50k-2024-09': 'Basic 50k',
  'advanced-1k-2024-09': 'Advanced 1k',
  'advanced-10k-2024-09': 'Advanced 10k',
  'advanced-25k-2024-09': 'Advanced 25k',
  'advanced-50k-2024-09': 'Advanced 50k',
  'annual-advanced-1k-2024-09': 'Advanced 1k',
  'annual-advanced-10k-2024-09': 'Advanced 10k',
  'annual-advanced-25k-2024-09': 'Advanced 25k',
  'annual-advanced-50k-2024-09': 'Advanced 50k',
  'free-2023-01': 'Build',
}

// phase 7
// add in increasing order of MAU
constVar.phase7PlansIDList = [
  'basic-1k-2026-01',
  'basic-10k-2026-01',
  'basic-25k-2026-01',
  'basic-50k-2026-01',
  'annual-basic-1k-2026-01',
  'annual-basic-10k-2026-01',
  'annual-basic-25k-2026-01',
  'annual-basic-50k-2026-01',
  'advanced-1k-2026-01',
  'advanced-10k-2026-01',
  'advanced-25k-2026-01',
  'advanced-50k-2026-01',
  'annual-advanced-1k-2026-01',
  'annual-advanced-10k-2026-01',
  'annual-advanced-25k-2026-01',
  'annual-advanced-50k-2026-01',
  'free-2023-01',
]

// phase 7
constVar.phase7PlanNameList = {
  'basic-1k-2026-01': 'Basic 1k',
  'basic-10k-2026-01': 'Basic 10k',
  'basic-25k-2026-01': 'Basic 25k',
  'basic-50k-2026-01': 'Basic 50k',
  'annual-basic-1k-2026-01': 'Basic 1k',
  'annual-basic-10k-2026-01': 'Basic 10k',
  'annual-basic-25k-2026-01': 'Basic 25k',
  'annual-basic-50k-2026-01': 'Basic 50k',
  'advanced-1k-2026-01': 'Advanced 1k',
  'advanced-10k-2026-01': 'Advanced 10k',
  'advanced-25k-2026-01': 'Advanced 25k',
  'advanced-50k-2026-01': 'Advanced 50k',
  'annual-advanced-1k-2026-01': 'Advanced 1k',
  'annual-advanced-10k-2026-01': 'Advanced 10k',
  'annual-advanced-25k-2026-01': 'Advanced 25k',
  'annual-advanced-50k-2026-01': 'Advanced 50k',
  'free-2023-01': 'Build',
}

// phase 7
constVar.phase7PlanFeatureList = [
  {
    plan: 'free-2023-01',
    title: 'Build Plan Features:',
    list: ['All features', 'Up to 100 users', 'No credit card required'],
    addonList: [],
  },
  {
    plan: 'basic-2026-01',
    title: 'Basic Plan Features:',
    list: ['Rich in-app chat', 'Push notifications', 'Basic moderation', 'Global EDGE network'],
    addonList: [],
  },
  {
    plan: 'advanced-2026-01',
    title: 'Everything in Basic, Plus:',
    list: [
      'AI Rule-based moderation',
      'Email & SMS notifications (with customizable templates)',
      'Multi-tenancy',
      'AI smart replies & summaries',
      'In-depth insights',
      'HIPAA / BAA',
      'Advanced search',
      'Message translation',
    ],
    addonList: [],
  },
  {
    plan: 'enterprise-2026-01',
    title: 'Everything in Advanced, Plus:',
    list: [
      'Zero overages',
      'OpenAI-powered context & prompt based moderation',
      'OpenAI-powered context & prompt based insights & enrichment',
    ],
    addonList: [
      '10% concurrency included',
      'Single Sign On (SSO) - SAML, LDAP and more included',
      'Custom white-label domain (add-on)',
    ],
  },
]

// phase 6
constVar.phase6PlanFeatureList = [
  {
    plan: 'free-2023-01',
    title: 'Build Plan Features:',
    list: ['All Features', 'Up To 100 Users', 'No Credit Card Required'],
    addonList: [],
  },
  {
    plan: 'basic-2024-09',
    title: 'Basic Plan Features:',
    list: [
      'Rich In-app Chat',
      'Push Notifications',
      'Advanced Moderation & Out-of-the-box Filters',
      'Global EDGE Network',
    ],
    addonList: [],
  },
  {
    plan: 'advanced-2024-09',
    title: 'Everything In Basic, Plus:',
    list: [
      'AI Rule-based Moderation',
      'Email & SMS Notifications',
      'Multi-tenancy',
      'AI User Copilot',
      'In-depth Insights',
      'HIPAA / BAA',
      'Advanced Search',
      'Message Translation',
    ],
    addonList: [],
  },
  {
    plan: 'enterprise-2024-09',
    title: 'Everything In Advanced, Plus:',
    list: [
      'Zero overages',
      'AI Rule-based & Context-based Moderation',
      'AI Context-based Insights',
      'AI Context-based Enrichment',
    ],
    addonList: [
      '10% Concurrency Included',
      '99.999% SLA',
      'Gold Implementation Included',
      'Gold Support Included',
    ],
  },
]

constVar.legacyNonCustomPlansIDList = ['meteoroid-(10-19)', 'asteroid-(10-19)']
constVar.trialPlansIDList = ['free', 'trial', 'free-2023-01']
constVar.expiredPlanIDList = ['free']
constVar.olderPlansIDList = ['pro-(2019)']
constVar.allPlanNamesList = [
  'Free',
  'Trial',
  'Meteoroid',
  'Asteroid',
  'Pro',
  'Moon',
  'Planet',
  'Startup',
  'Growth',
  'Scale',
  'Enterprise',
  'Single',
  'Multiple',
  'Multi',
  'Essentials',
  'Developer',
  'Basic',
  'Advanced',
]
constVar.uniqHashString = 'c0m3tch@tpr0!'
constVar.perPageInListings = 10
constVar.perPageAppsListing = 12
constVar.perPageCredentialListings = 3
constVar.ManualOutreachIntents = {
  'app-create-request-us-hipaa-compliant': 'app-create-request-us-hipaa-compliant', // not used anymore
  'change-custom-plan': 'change-custom-plan', // zendesk chat
  'add-higher-plan-extension': 'add-higher-plan-extension',
  'import-users-request': 'import-users-request', // zendesk chat
  'subscribe-to-custom-plan-request': 'subscribe-to-custom-plan-request', // zendesk chat
  'app-migration-request-to-v3': 'app-migration-request-to-v3', // not used anymore
  'restore-app-scheduled-for-deletion-request': 'restore-app-scheduled-for-deletion-request', // not used
  'upgrade-plan-since-feature-restricted': 'upgrade-plan-since-feature-restricted',
  'export-messages-exceeding-100k-request': 'export-messages-exceeding-100k-request',
  'customer-switched-to-new-dashboard': 'customer-switched-to-new-dashboard', // not used
  'customer-switched-to-old-dashboard': 'customer-switched-to-old-dashboard', // not used
  'slack-connect-request': 'slack-connect-request', // slack support
  'unread-badge-count-toggle-request': 'unread-badge-count-toggle-request', // zendesk ticket for enabling/disabling unread badge count
  'contact-us-agentic-pricing': 'contact-us-agentic-pricing', // agentic pricing contact us
  'transfer-ownership-request': 'transfer-ownership-request', // manual outreach to update app owner at chargebee end
}

constVar.GAEvents = {
  user_signup: 'user_signup',
  app_creation: 'app_creation',
  plan_subscribe: 'plan_subscribe',
  plan_unsubscribe: 'plan_unsubscribe',
  plan_upgrade: 'plan_upgrade',
  plan_downgrade: 'plan_downgrade',
  plan_resubscribe: 'plan_resubscribe',
  user_login: 'user_login',
  user_login_otp_sent: 'user_login_otp_sent',
  plan_card_added: 'plan_card_added',
  plan_downgrade_cancel: 'plan_downgrade_cancel',
  user_awaiting_verification: 'user_awaiting_verification',
}

constVar.teamRoles = {
  owner: 'owner',
  admin: 'admin',
  moderator: 'moderator',
  developer: 'developer',
}

constVar.phase3PlansIDList = [
  'startup-1k-(2021-01)',
  'startup-10k-(2021-01)',
  'startup-25k-(2021-01)',
  'startup-50k-(2021-01)',
  'startup-100k-(2021-01)',
  'growth-1k-(2021-01)',
  'growth-10k-(2021-01)',
  'growth-25k-(2021-01)',
  'growth-50k-(2021-01)',
  'growth-100k-(2021-01)',
  'scale-1k-(2021-01)',
  'scale-10k-(2021-01)',
  'scale-25k-(2021-01)',
  'scale-50k-(2021-01)',
  'scale-100k-(2021-01)',
  'single-25-(2021-01)',
  'single-100-(2021-01)',
  'single-1k-(2021-03)',
  'single-2500-(2021-03)',
  'single-5k-(2021-03)',
  'single-10k-(2021-03)',
  'free-25-(2021-01)',
]

constVar.activePlansUnsubscribeRestricted = [
  'single-100-(2021-01)',
  'single-1k-(2021-03)',
  'single-2500-(2021-03)',
  'single-5k-(2021-03)',
  'single-10k-(2021-03)',
]

constVar.phase3Pay0PlanIDs = ['free-25-(2021-01)', 'single-25-(2021-01)']

constVar.phase3PlanFreeIDCategories = {
  appDeveloper: 'free-25-(2021-01)',
  eventOrganizer: 'single-25-(2021-01)',
}

constVar.plansPermittedToSubscribeEventPlans = [
  'trial',
  'free',
  'free-25-(2021-01)',
  'single-25-(2021-01)',
  'single-100-(2021-01)',
  'single-1k-(2021-03)',
  'single-2500-(2021-03)',
  'single-5k-(2021-03)',
  'single-10k-(2021-03)',
  'essentials-1k-2023-01',
  'essentials-10k-2023-01',
  'essentials-25k-2023-01',
  'essentials-50k-2023-01',
  'pro-1k-2023-01',
  'pro-10k-2023-01',
  'pro-25k-2023-01',
  'pro-50k-2023-01',
  'free-2023-01',
]

constVar.developerPlanID = 'free-2023-01'

constVar.plansNotPermittedToSubscribeDeveloperPlans = [
  'single-25-(2021-01)',
  'single-100-(2021-01)',
  'single-1k-(2021-03)',
  'single-2500-(2021-03)',
  'single-5k-(2021-03)',
  'single-10k-(2021-03)',
]

constVar.planNamesPermittingTeamFeature = [
  // 'Moon',
  // 'Planet',
  'Scale',
  'Enterprise',
  'Unlimited Events',
  'Multi-tenant',
]
constVar.passwordIndicatorLabels = ['delicate', 'weak', 'okay', 'good', 'strong']

constVar.sdkAnalyticsVersions = {
  javascript: '2.2.0',
  android: '2.2.0',
  ios: '2.2.0',
  react_native: '2.2.0',
  ionic: '2.2.0',
}
constVar.sdkAnalyticsVersionAcross = '2.2.0'

constVar.chatWidgetDefaults = {
  docked_layout_icon_open: 'https://widget-js.cometchat.io/v2/resources/chat_bubble.svg',
  docked_layout_icon_close: 'https://widget-js.cometchat.io/v2/resources/chat_close.svg',
  docked_layout_icon_background: '#03a9f4',
}

constVar.featureSlugList = {
  legacy_webhooks: 'features.webhooks.enabled',
  advanced_webhooks_accessible: 'features.advanced.webhooks.accessible',
  advanced_webhooks_included: 'features.advanced.webhooks.included',
  advanced_webhooks_enabled: 'features.advanced.webhooks.enabled',
  advanced_plus_webhooks_accessible: 'features.advanced-plus.webhooks.accessible',
  advanced_plus_webhooks_included: 'features.advanced-plus.webhooks.included',
  advanced_plus_webhooks_enabled: 'features.advanced-plus.webhooks.enabled',
  basic_webhooks_accessible: 'features.basic.webhooks.accessible',
  basic_webhooks_included: 'features.basic.webhooks.included',
  basic_webhooks_enabled: 'features.basic.webhooks.enabled',
  bots: 'features.bots.enabled',
  team_management: 'dashboard.team.management.enabled',
  usage_analytics: 'dashboard.analytics.usage.enabled',
  message_moderation: 'dashboard.messages.moderation.enabled',
  users: 'dashboard.users.management.enabled',
  groups: 'dashboard.groups.management.enabled',
  extension_in_flight_message_moderation: 'features.moderation.inflight-message-moderation.enabled',
  threaded_conversations_and_replies: 'core.chat.messages.replies.enabled',
  share_files_and_multimedia: 'core.chat.messages.media.enabled',
  record_send_voice_messages: 'core.chat.voice-notes.enabled',
  typing_indicators: 'core.chat.typing-indicator.enabled',
  read_receipts: 'core.chat.messages.receipts.enabled',
  user_presence: 'core.chat.users.presence.enabled',
  call_recording: 'core.call.recording.enabled',
  one_on_one_voice_call: 'core.call.one-on-one.audio.enabled',
  one_on_one_video_call: 'core.call.one-on-one.video.enabled',
  group_voice_call: 'core.call.groups.audio.enabled',
  group_video_call: 'core.call.groups.video.enabled',
  extension_stickers: 'features.ue.stickers.enabled',
  extension_reactions: 'features.ue.reactions.enabled',
  extension_polls: 'features.ue.polls.enabled',
  extension_document: 'features.collaboration.document.enabled',
  extension_whiteboard: 'features.collaboration.whiteboard.enabled',
  extension_mentions: 'features.ue.mentions.enabled',
  live_reactions: 'features.ue.live-reactions.enabled',
  extension_smart_reply: 'features.ue.smart-replies.enabled',
  extension_link_preview: 'features.ux.link-preview.enabled',
  extension_thumbnail_generation: 'features.ux.thumbnail-generation.enabled',
  extension_save_message: 'features.ux.messages.saved.enabled',
  extension_pin_message: 'features.ux.messages.pinned.enabled',
  extension_rich_media: 'features.ux.rich-media-preview.enabled',
  extension_voice_transcription: 'features.ux.voice-transcription.enabled',
  extension_profanity_filter: 'features.moderation.profanity-filter.enabled',
  extension_image_moderation: 'features.moderation.image-moderation.enabled',
  extension_data_masking: 'features.moderation.data-masking.enabled',
  extension_virus_malware_scanner: 'features.moderation.malware-scanner.enabled',
  extension_sentiment_analysis: 'features.moderation.sentiment-analysis.enabled',
  extension_human_moderation: 'features.moderation.inflight-message-moderation.enabled',
  extension_message_translation: 'features.ue.message-translation.enabled',
  extension_widget: 'integrations.chat-widget.enabled',
  extension_emojis: 'features.ue.emojis.enabled',
  extension_xss_filter: 'features.moderation.xss-filter.enabled',
  extension_email_notification: 'features.notifications.email-notification.enabled',
  extension_push_notification: 'features.notifications.push-notification.enabled',
  extension_sms_notification: 'features.notifications.sms-notification.enabled',
  notification_logging_enabled: 'core.notifications.logs.enabledAtMS',
  notification_logging_disabled: 'core.notifications.logs.disabledAtMS',
  notification_logging_disable_after_days: 'core.notifications.logs.disableAfterDays',
  extension_broadcast: 'features.ue.video-broadcasting.enabled',
  user_to_user_blocking: 'features.moderation.users.block.enabled',
  group_moderators: 'features.moderation.groups.moderators.enabled',
  group_kick_member: 'features.moderation.groups.kick.enabled',
  group_ban_member: 'features.moderation.groups.ban.enabled',
  extension_gifs_giphy: 'features.ue.giphy.enabled',
  extension_gifs_tenor: 'features.ue.tenor.enabled',
  extension_gifs_gfycat: 'features.ue.gfycat.enabled',
  extension_email_replies: 'features.ue.email-replies.enabled',
  extension_url_shortener_tinyurl: 'features.ux.url-shortener.enabled',
  extension_url_shortener_bitly: 'features.ux.url-shortener-bitly.enabled',
  extension_stickers_stipop: 'features.ue.stipop.enabled',
  extension_disappearing_messages: 'features.security.disappearing-messages.enabled',
  extension_e2ee: 'security.end-to-end-encryption.enabled',
  extension_reminders: 'features.ue.reminders.enabled',
  extension_intercom: 'customersupport.intercom.enabled',
  extension_chatwoot: 'customersupport.chatwoot.enabled',
  extension_avatar: 'features.ux.avatar.enabled',
  extension_message_shortcuts: 'features.ux.message-shortcuts.enabled',
  extension_live_migration_applozic: 'features.lm.live-migration-applozic.enabled',
  extension_report_user: 'features.moderation.report-user.enabled',
  extension_report_message: 'features.moderation.report-message.enabled',
  extension_slow_mode: 'features.moderation.slow-mode.enabled',
  advanced_moderation_enabled: 'features.moderation.advanced.enabled',
  advanced_moderation: 'features.moderation.advanced.accessible',
  advanced_moderation_rule_creation: 'features.moderation.advanced.rule-creation.enabled',
  advanced_moderation_advanced_plus_rules_enabled:
    'features.moderation.advanced-plus.rules.enabled',
  advanced_moderation_advanced_plus_rules_included:
    'features.moderation.advanced-plus.rules.included',
  advanced_moderation_advanced_rules_enabled: 'features.moderation.advanced.rules.enabled',
  advanced_moderation_advanced_rules_included: 'features.moderation.advanced.rules.included',
  advanced_moderation_basic_rules_enabled: 'features.moderation.basic.rules.enabled',
  basic_moderation_basic_rules_included: 'features.moderation.basic.rules.included',
  advanced_moderation_advanced_keywords_enabled: 'features.moderation.advanced.keywords.enabled',
  umc_group_read_and_delivered_to_all_enabled: 'core.chat.unread-message-count.enabled',
  umc_group_read_and_delivered_to_all_accessible: 'core.chat.unread-message-count.accessible',
  advanced_search_accessible: 'core.advanced.search.accessible',
  advanced_search_enabled: 'core.advanced.search.enabled',
  notifications_push_accessible: 'core.notifications.push.accessible',
  notifications_email_accessible: 'core.notifications.email.accessible',
  notifications_sms_accessible: 'core.notifications.sms.accessible',
  notifications_push_advanced_enabled: 'core.notifications.push.advanced.enabled',
  notifications_sms_advanced_enabled: 'core.notifications.sms.advanced.enabled',
  notifications_email_advanced_enabled: 'core.notifications.email.advanced.enabled',
  notifications_push_advanced_included: 'core.notifications.push.advanced.included',
  notifications_email_advanced_included: 'core.notifications.email.advanced.included',
  notifications_sms_advanced_included: 'core.notifications.sms.advanced.included',
  notifications_push_enabled: 'core.notifications.push.enabled',
  notifications_sms_enabled: 'core.notifications.sms.enabled',
  notifications_email_enabled: 'core.notifications.email.enabled',
  notifications_unread_badge_count_accessible: 'core.notifications.unreadBadgeCount.accessible',
  notifications_unread_badge_count_enabled: 'core.notifications.unreadBadgeCount.enabled',
  ai_accessible: 'features.ai.accessible',
  ai_bots_accessible: 'features.ai.bots.accessible',
  ai_enabled: 'features.ai.enabled',
  insights_enabled: 'dashboard.analytics.advanced.enabled',
  insights_url: 'dashboard.analytics.insights.url',
  quoted_replies: 'core.chat.messages.quoted-replies.enabled',
}

// phase 6
// add in increasing order of MAU
constVar.phase6PlansIDList = [
  'basic-1k-2024-09',
  'basic-10k-2024-09',
  'basic-25k-2024-09',
  'basic-50k-2024-09',
  'annual-basic-1k-2024-09',
  'annual-basic-10k-2024-09',
  'annual-basic-25k-2024-09',
  'annual-basic-50k-2024-09',
  'advanced-1k-2024-09',
  'advanced-10k-2024-09',
  'advanced-25k-2024-09',
  'advanced-50k-2024-09',
  'annual-advanced-1k-2024-09',
  'annual-advanced-10k-2024-09',
  'annual-advanced-25k-2024-09',
  'annual-advanced-50k-2024-09',
  'free-2023-01',
]

constVar.timeout_in_ms = {
  metrics: '60000',
}

constVar.messages_filter_export_call_limit = 100

constVar.betaTriggerList = {
  after_user_status_changed: {
    id: 'after_user_status_changed',
    name: 'after_user_status_changed (beta)',
  },
}

constVar.moderationMessageStatuses = {
  approve: 'approve',
}

constVar.featureDeprecatedTimestamps = {
  legacy_widgets: 1753972200, // 2025-07-31 8PM
  ai_bots: 1793491200, // 2025-08-15 00:00AM // Updated this date from 15th august 2025 to 1 November 2026 00:00:00
  legacy_user_role_permission: 1771848000, // 2026-02-23 17:30:00 IST (12:00:00 UTC)
}

constVar.comingSoonText = 'Coming Soon'
constVar.futureTechs = []

constVar.cometchatNewAuthKey = `COMETCHAT_AUTH_KEY_${new Date().getTime()}`

constVar.docsURL = {
  reactUIKit: 'https://www.cometchat.com/docs/ui-kit/react/overview',
  reactUIKitAgent: 'https://www.cometchat.com/docs/ui-kit/react/ai-assistant-chat',
  reactNativeUIKitAgent: 'https://www.cometchat.com/docs/ui-kit/react-native/guide-ai-agent',
  androidUIKitAgent: 'https://www.cometchat.com/docs/ui-kit/android/guide-ai-agent',
  iosUIKitAgent: 'https://www.cometchat.com/docs/ui-kit/ios/guide-ai-agent',
  flutterUIKitAgent: 'https://www.cometchat.com/docs/ui-kit/flutter/guide-message-agentic-flow',
  chatWidgetAgent: 'https://www.cometchat.com/docs/ai-agents/chat-widget',

  // SDks
  jsSDK: 'https://www.cometchat.com/docs/sdk/javascript/overview',
  jsSdkAgent: 'https://www.cometchat.com/docs/sdk/javascript/ai-agents',
  androidSdkAgent: 'https://www.cometchat.com/docs/sdk/android/ai-agents',
  flutterSdkAgent: 'https://www.cometchat.com/docs/sdk/android/ai-agents',
  reactNativeSdkAgent: 'https://www.cometchat.com/docs/sdk/android/ai-agents',
}

constVar.avoidOnboardingActionsRoutes = [
  '/verify/email',
  '/choose-role',
  '/choose-intent',
  '/create-your-first-app',
  '/schedule-your-kick-off-call',
]

constVar.customCategoryLimit = 5
constVar.flaggedByUsersTableCount = 5

constVar.vcbDemoApp = {
  APP_ID: '267879a77f4b29cd',
  REGION: 'in',
  AUTH_TOKEN_URL: 'https://demo-service.cc-cluster-2.io/auth-token',
}

const constants = constVar
export default constants
